import { format, isValid, parseISO } from 'date-fns'

const DOT_DATE = /^\d{2}\.\d{2}\.\d{4}$/

function parsePromotionDate(value: string): Date | null {
  const isoLike = value.includes('T') ? value : value.replace(' ', 'T')
  const parsedIso = parseISO(isoLike)

  if (isValid(parsedIso)) {
    return parsedIso
  }

  const parsed = new Date(value)

  return isValid(parsed) ? parsed : null
}

/**
 * Дата акции в формате `dd.MM.yyyy`.
 *
 * Django-фильтр `date:'d.m.Y'` мог уже отдать готовую строку —
 * тогда она возвращается без повторного парсинга.
 */
export default function formatPromotionDate(value?: string): string {
  if (!value) {
    return ''
  }

  if (DOT_DATE.test(value)) {
    return value
  }

  const date = parsePromotionDate(value)

  return date ? format(date, 'dd.MM.yyyy') : value
}
